/**
 * Public apply contract. The handler at POST /hiring/api/apply is the only
 * unauthenticated mutation in the product. Operations may set the
 * `public: true` discriminator on the Operation; the route handler can
 * read it and skip operator-cookie checks. (createRoute is permissive
 * by default — the discriminator is documentation; no shell-side cookie
 * gate exists today. If one is added, this flag is the contract.)
 */
import { z } from "zod";
import type { Operation } from "../types";

export const applyResultSchema = z.object({
  ok: z.literal(true),
  note: z.enum(["created", "already_applied"]),
});
export type ApplyResult = z.infer<typeof applyResultSchema>;

export interface PublicOperation<
  TParams = void,
  TQuery = void,
  TBody = void,
  TResult = unknown,
> extends Operation<TParams, TQuery, TBody, TResult> {
  public?: true;
}

/**
 * Apply form is submitted as multipart/form-data (file + fields). The body
 * type is FormData — zod cannot parse multipart, and the Hono handler still
 * reads `c.req.raw.formData()` by hand. `apiCall` detects FormData and sends
 * it without a JSON Content-Type (#44447). Public (no session).
 */
export const apply: PublicOperation<void, void, FormData, ApplyResult> = {
  method: "POST",
  path: () => "/hiring/api/apply",
  response: applyResultSchema,
  public: true,
};
